export enum FadeInAnimation {
  FIRST = 'Animation_FirstFadeIn',
  SECOND = 'Animation_SecondFadeIn',
  THIRD = 'Animation_ThirdFadeIn',
  FOUR = 'Animation_FourFadeIn',
}
